import Swiper, {
  Navigation, Pagination, Autoplay
} from 'swiper';
import 'swiper/swiper-bundle.min.css';

Swiper.use([Navigation, Pagination, Autoplay]);

export function initRGuidesBlockSlider() {
  const sliders = document.querySelectorAll('[data-r-guides-block-slider]');

  if (sliders.length) {
    const breakpoint = window.matchMedia('(min-width:768px)');
    let swiperGuides = [];

    // eslint-disable-next-line
    function breakpointChecker() {
      if (breakpoint.matches === true) {
        if (swiperGuides.length > 0) {
          swiperGuides.forEach((slider) => slider.destroy(true, true));
          swiperGuides = [];
        }
      } else if (breakpoint.matches === false) {
        enableSwiper();
      }
    }

    // eslint-disable-next-line
    function enableSwiper() {
      sliders.forEach((sliderEl) => {
        const slider = new Swiper(sliderEl, {
          slidesPerView : 1,
          spaceBetween  : 8,
          loop          : false,
          arrows        : false,
          speed         : 1000,
          pagination    : {
            el        : sliderEl.querySelector('.swiper-pagination'),
            clickable : true,
            type      : 'custom',
            renderCustom(swiper, current, total) {
              let out = '';
              for (let i = 1; i < total + 1; i += 1) {
                if (i === current) {
                  out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=${i} role="button"></span>`;
                } else {
                  out = `${out}<span class="swiper-pagination-bullet" tabindex=${i} role="button"></span>`;
                }
              }
              return out;
            }
          }
        });

        swiperGuides.push(slider);
      });
    }

    breakpointChecker();

    window.addEventListener('resize', () => {
      breakpointChecker();
    });

    window.dispatchEvent(new Event('resize'));
  }
}
